export enum KeyboardShortcut {
  ADD_OBSERVATION = 'r',
  ESCAPE = 'escape',
  FREE_MOUSE = 'e',
  FORWARD = 'w',
  LEFT = 'a',
  BACKWARD = 's',
  RIGHT = 'd',
  UP = ' ',
  DOWN = 'shift',
  TOGGLE_SPEED_BOOST = 'tab',
  TOGGLE_POINT_CLOUD_RENDERER = '\\',
}
